export const getSendThirdPartyPaymentEmailError = (state) => state.sendThirdPartyPaymentEmailError;
export const getSendThirdPartyPaymentEmailSuccess = (state) => state.sendThirdPartyPaymentEmailSuccess;
export const getIsSendThirdPartyPaymentEmailLoading = (state) => state.isSendThirdPartyPaymentEmailLoading;
export const getSelectedEducation = (state) => state.selectedEducation;
export default {
    getSendThirdPartyPaymentEmailError,
    getSendThirdPartyPaymentEmailSuccess,
    getIsSendThirdPartyPaymentEmailLoading,
    getSelectedEducation,
};
